import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { ShelterAppStateModel } from "../../../../petszel-shelter/src/app/store/ShelterAppStateModel";
import * as authActions from "../../../../petszel-shelter/src/app/store/auth/auth.actions";

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  private logoutTimeout: any;

  constructor(private store: Store<ShelterAppStateModel>) {
    this.logoutTimeout = null;
  }

  logoutAfterDelay(delay: number) {
    // Clear any existing timeout to prevent multiple logout calls
    this.clearLogoutTimeout();
    // Set the new logout timeout
    this.logoutTimeout = setTimeout(() => {
      this.clearAllLocalStorage(); // Clear all local storage items

      this.logout();
    }, delay);
  }

  logout() {
    this.clearAllLocalStorage(); // Clear all local storage items
    this.store.dispatch(authActions.logout());
  }

  logoutBtn() {
    this.clearLogoutTimeout();
    this.logout();
  }

  private clearLogoutTimeout() {
    if (this.logoutTimeout) {
      clearTimeout(this.logoutTimeout);
      this.logoutTimeout = null;
    }
  }

  private clearAllLocalStorage() {
    localStorage.clear(); // Clears all items in local storage
  }
}
